import React from 'react';
import { string, func, bool } from 'prop-types';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';
import './MoreSpecsButton.scss';

export default function MoreSpecsButton({ className, active, onClick }) {
    const rootClassnames = classnames('more-specs-button', className);
    const chevronClassnames = classnames('more-specs-button__chevron-down', {
        'more-specs-button__chevron-down--active': active,
    });

    return (
        <button className={rootClassnames} onClick={onClick}>
            <div className="more-specs-button__label">
                {active ? (
                    <FormattedMessage
                        id="listing.productCard.mobile.moreSpecsButton.hide"
                        defaultMessage="Hide characteristics"
                        description="Hide characteristic button label on mobile product card"
                    />
                ) : (
                    <FormattedMessage
                        id="listing.productCard.mobile.moreSpecsButton.show"
                        defaultMessage="Show characteristics"
                        description="Show characteristic button label on mobile product card"
                    />
                )}
            </div>
            <span className={chevronClassnames} />
        </button>
    );
}

MoreSpecsButton.propTypes = {
    className: string,
    active: bool,
    onClick: func,
};

MoreSpecsButton.defaultProps = {
    className: null,
    active: false,
    onClick: null,
};
